import { render } from "./AddPage.vue?vue&type=template&id=19ec3a7f&scoped=true"
import script from "./AddPage.vue?vue&type=script&lang=js"
export * from "./AddPage.vue?vue&type=script&lang=js"

import "./AddPage.vue?vue&type=style&index=0&id=19ec3a7f&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ec3a7f"]])

export default __exports__